// extracted by mini-css-extract-plugin
export default {"starsRow":"StarRatings_starsRow__PwSyD","starIcon":"StarRatings_starIcon__cTEsn"};